export enum BankAccountType {
  Checking = 'Checking',
  Savings = 'Savings',
  Business = 'Business',
}
